export default function (context, val) {
    context.commit('set_form', {
        PaymentAccountId: val,
    });
}